export const DEFAULT_APPLICATION_ROWS = [
  { key: 'trade_name', value: '' },
  { key: 'contact_person', value: '' },
  { key: 'contact_phone', value: '' },
  { key: 'application_note', value: '' },
];

export const objectToRows = value => {
  const entries = Object.entries(value || {});
  return entries.length
    ? entries.map(([key, item]) => ({ key, value: typeof item === 'object' ? JSON.stringify(item) : String(item ?? '') }))
    : DEFAULT_APPLICATION_ROWS.map(item => ({ ...item }));
};

export const rowsToObject = rows => Object.fromEntries(rows
  .map(row => [String(row.key || '').trim().replace(/\s+/g, '_').toLowerCase(), String(row.value ?? '').trim()])
  .filter(([key, value]) => key && value));

